import React from "react";

import OverviewGridLayout from "../../components/Overview/GridLayout";
import { SupplyChainOverviewConfigure } from "../../models/supply.chain.overview.configure";

interface Props {
  panel: keyof SupplyChainOverviewConfigure;
}

const OverviewContainer = ({ panel }: Props) => {
  return <OverviewGridLayout panel={panel} />;
};

export default OverviewContainer;
